// Templates de texto do usuario (ate 10), escrita via RPC.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { UserTemplate } from "@lucralink/shared";
import { supabase } from "@/lib/supabase";

const templatesKey = ["text-templates"] as const;

async function fetchTemplates(): Promise<UserTemplate[]> {
  const { data, error } = await supabase
    .from("text_templates")
    .select("id, name, body")
    .order("created_at", { ascending: true });
  if (error) throw error;
  return (data ?? []) as UserTemplate[];
}

export function useTextTemplates() {
  return useQuery<UserTemplate[], Error>({
    queryKey: templatesKey,
    queryFn: fetchTemplates,
    staleTime: 30_000,
  });
}

export function useSaveTextTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      id: string | null;
      name: string;
      body: string;
    }): Promise<UserTemplate> => {
      const { data, error } = await supabase.rpc("upsert_text_template", {
        p_id: input.id,
        p_name: input.name,
        p_body: input.body,
      });
      if (error) throw error;
      return data as UserTemplate;
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: templatesKey });
    },
  });
}

export function useDeleteTextTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.rpc("delete_text_template", { p_id: id });
      if (error) throw error;
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: templatesKey });
      // delete_text_template limpa refs no padrao global
      await qc.invalidateQueries({ queryKey: ["forwarding-settings"] });
    },
  });
}
